import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog__header flex flex-column w-8" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "flex flex-column" }
const _hoisted_4 = { class: "w-full my-3 flex flex-column gap-1" }

import { ref, toRefs } from 'vue';
import Dialog from 'primevue/dialog';
import { useRelayHubStore } from '@/store';
import { EMIT } from '@/enum';
import { TreeNode } from 'primevue/treenode';

interface Props {
  organization: TreeNode;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'EditOrganizationModal',
  props: {
    organization: {}
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;
const { organization } = toRefs(props);

const relayHubStore = useRelayHubStore();

const selectedItem = ref();
const district_medicaid_code = ref<string>(organization.value.medicaid_district_code || '');

const emit = __emit;

const modalVisible = ref(true);

const save = async () => {
  organization.value.medicaid_district_code = district_medicaid_code.value;
  await relayHubStore.updateOrganizationDistrictCode(district_medicaid_code.value, organization.value.id);

  if (relayHubStore.error) relayHubStore.doToast(relayHubStore.error as string, 'Error', true);
  else relayHubStore.doToast('Organization Updated');

  emit(EMIT.SAVE);
};

const cancel = () => {
  selectedItem.value = null;
  emit(EMIT.CANCEL);
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((modalVisible).value = $event)),
    class: "dialog__container",
    modal: true,
    draggable: false,
    onHide: cancel
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, "Edit " + _toDisplayString(_unref(organization).name), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        type: "secondary",
        text: "Cancel",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        type: "primary",
        text: "Save",
        disabled: !district_medicaid_code.value,
        onClick: save
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("label", {
            class: "required",
            for: "dmc"
          }, "District Medicaid Code", -1)),
          _createVNode(_component_InputText, {
            id: "dmc",
            modelValue: district_medicaid_code.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((district_medicaid_code).value = $event)),
            class: "w-full"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})